/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.server.defs'

type $nsid = typeof $nsid

export { $nsid }

type InviteCode = {
  $type?: 'com.atproto.server.defs#inviteCode'
  code: string
  available: number
  disabled: boolean
  forAccount: string
  createdBy: string
  createdAt: l.DatetimeString
  uses: InviteCodeUse[]
}

export type { InviteCode }

const inviteCode = /*#__PURE__*/ l.typedObject<InviteCode>(
  $nsid,
  'inviteCode',
  /*#__PURE__*/ l.object({
    code: /*#__PURE__*/ l.string(),
    available: /*#__PURE__*/ l.integer(),
    disabled: /*#__PURE__*/ l.boolean(),
    forAccount: /*#__PURE__*/ l.string(),
    createdBy: /*#__PURE__*/ l.string(),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    uses: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<InviteCodeUse>((() => inviteCodeUse) as any),
    ),
  }),
)

export { inviteCode }

type InviteCodeUse = {
  $type?: 'com.atproto.server.defs#inviteCodeUse'
  usedBy: l.DidString
  usedAt: l.DatetimeString
}

export type { InviteCodeUse }

const inviteCodeUse = /*#__PURE__*/ l.typedObject<InviteCodeUse>(
  $nsid,
  'inviteCodeUse',
  /*#__PURE__*/ l.object({
    usedBy: /*#__PURE__*/ l.string({ format: 'did' }),
    usedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { inviteCodeUse }
